import { Link } from "react-router-dom";
import { Calculator, ExternalLink } from "lucide-react";
import { CATEGORIES } from "../../config/categories";
import { getCalculatorsByCategory } from "../../config/calculators";
import { MAIN_SITE_URL } from "../../config/articles";
import { DATA_YEAR } from "../../lib/financial-data/canada";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-[#F3F6F4]">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand text-white">
                <Calculator className="h-5 w-5" />
              </span>
              <span className="font-heading text-lg font-bold text-brand">MyFinancesGuru <span className="text-action">Tools</span></span>
            </Link>
            <p className="mt-4 max-w-xs text-sm text-muted-foreground">
              Free, trustworthy Canadian financial calculators. Free value first — always. All calculations run privately in your browser.
            </p>
          </div>

          {CATEGORIES.slice(0, 3).map((cat) => (
            <div key={cat.id}>
              <h4 className="font-heading text-sm font-bold uppercase tracking-wide text-foreground">{cat.name}</h4>
              <ul className="mt-3 space-y-2">
                {getCalculatorsByCategory(cat.id).map((c) => (
                  <li key={c.slug}>
                    <Link to={`/calculators/${c.slug}`} className="text-sm text-muted-foreground transition-colors hover:text-brand">
                      {c.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 grid gap-8 border-t border-border pt-8 md:grid-cols-2 lg:grid-cols-4">
          {CATEGORIES.slice(3).map((cat) => (
            <div key={cat.id}>
              <h4 className="font-heading text-sm font-bold uppercase tracking-wide text-foreground">{cat.name}</h4>
              <ul className="mt-3 space-y-2">
                {getCalculatorsByCategory(cat.id).map((c) => (
                  <li key={c.slug}>
                    <Link to={`/calculators/${c.slug}`} className="text-sm text-muted-foreground transition-colors hover:text-brand">{c.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wide text-foreground">Company</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/products" className="transition-colors hover:text-brand">Products</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-brand">About</Link></li>
              <li><Link to="/contact" className="transition-colors hover:text-brand">Contact</Link></li>
              <li><a href={MAIN_SITE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 transition-colors hover:text-brand">Main blog <ExternalLink className="h-3 w-3" /></a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wide text-foreground">Legal</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="transition-colors hover:text-brand">Privacy Policy</Link></li>
              <li><Link to="/terms" className="transition-colors hover:text-brand">Terms of Use</Link></li>
              <li><Link to="/disclaimer" className="transition-colors hover:text-brand">Disclaimer</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-border pt-6 text-xs leading-relaxed text-muted-foreground">
          <p>
            <strong>Disclaimer:</strong> The calculators and content on MyFinancesGuru Tools are for general educational and informational purposes only and do not constitute financial, tax, legal or investment advice. Figures are estimates. Canadian financial data reflects the {DATA_YEAR} tax year and should be verified against official sources before you make decisions.
          </p>
          <p className="mt-3">© {new Date().getFullYear()} MyFinancesGuru. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
